import {filter, map, shareReplay, startWith} from 'rxjs/operators';
import type {Observable} from 'rxjs';
import {wwData$} from './worker-data';

export const wallets$: Observable<SpotWallet[]> = wwData$.pipe(
  filter((o) => o.type === 'spot-wallets'),
  map((o) => <SpotWallet[]>o.data.wallets),
  startWith([]),
  shareReplay(1)
);

wallets$.subscribe();
